import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';

import { Table } from '../components/CommonTable';
import PrimeToBranchButton from '../components/button/PrimeToBranchButton';
import PrimeContractorButton from '../components/button/PrimeContractorButton';
import RoleButton from '../components/button/RoleButton';
import { Information } from '../components/modals/common';
import { UserTypeSwitchForm } from '../components/UserTypeSwitchForm';
import PrimeEnabler from '../components/toggle/PrimeEnabler';
import { FormDropDownSingleSelect } from '../components/CommonFormComponents';
import Tippy, { ToolTip } from '../components/ReactTippy';
import { MasterPageHeader } from '../components/PageHeader';
import FieldsSystemNotices from './FieldsSystemNotices';
import { FieldsExpiredUsageModal } from '../components/modals/FieldsExpiredUsageModal';
import { StatusTag } from '../components/StatusTag';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  REQUEST_PARAMS,
  APPROVAL_STATUS,
  FIELD_COMPLETE_STATUS,
  ENTER_STATUS,
  CONTRACT_FLAG,
  PAGE_REFERER,
  BUILDEE_SERVICES,
  ZENDESK_URL_GUIDE,
  LIST_SERVICES,
  CCUS_REGISTER_STATUS,
} from '../utilities/constants';
import fetchMg from '../utilities/fetchManager';
import EventManager, {
  createLocalEventManager,
  EventType,
} from '../utilities/EventManager';
import LocalStorageService from '../services/utilities/LocalStorageService';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  isPrimaryCompany,
  isPartnerCompany,
  roleIdToRoleName,
  isPartnerRoleId,
  isTargetRoleId,
  isPartnerCompanyRoleId,
  isLoginUserPartnerCompany,
  isLoginUserPartner,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import { getSortButton } from '../utilities/sortUtility';
import styles from '../styles/componentStyle/entrance/fields.scss';
import { messageUtility } from '../utilities/messageUtility';
import {
  csvDownloader,
  getCompanyId,
  checkCallBackGreenFileService,
} from '../utilities/commonUtil';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import {
  goChangedFieldPage,
  createFieldsDefaultSearchParams,
  saveFieldData,
  getAvailableServiceId,
  getFieldStatus,
} from '../utilities/fieldUtil';
import { isNullOrEmpty, isNullOrUndefined } from '../utilities/stringUtil';
import {
  getPermissionByServiceIdAndCompanyId,
  noPermissionDialog,
} from '../utilities/companyUserPermissionUtil';
import dialogLoader from '../utilities/dialogLoader';
import { setFieldNameForGTM } from '../utilities/gtm';
import { UserProfileService } from '../services/UserProfiles';
import { CompanyBranchService } from '../services/CompanyBranches';
import CompanyService from '../services/Companies';
import { JVListsData } from '../services/FieldTree';

moment.locale('ja');

const MY_EVENT = {
  GET_COMPANY: 'get_company', // 検索フォームの元請検索で使う
  SEARCH_FORM_CHANGE: 'search_form_change', // params変更イベント
};

const LocalEventMg = createLocalEventManager(MY_EVENT);
const SELECT_COMPANY_NAME_LABEL = '元請名を選択'; // 元請コンポーネントラベル名
const SEARCH_COMPONENT_BRANCH_LABEL = '支店名を選択'; // 支店コンポーネントラベル名

/**
 * @description 現場一覧画面
 */
export class Fields extends React.Component {
  constructor(props) {
    super(props);

    const params = createFieldsDefaultSearchParams();

    this.state = {
      params, // 検索条件
      tempParams: params, // 検索条件(保管用)
      total: 0, // 取得現場件数
      isSearchFormOpen: true, // 検索フォームの開閉
      afterLoginEventsFlag: !!SessionStorageService.getAfterLoginEventsFlag(), // ログイン直後の任意のイベント終了フラグ
      userRoleId: LocalStorageService.getRoleId(), // ログインユーザーの権限
      showFieldsSessionPartner: false, // 元請会社選択モーダル表示
      contractFlag: SessionStorageService.getContractFlag(), // 契約フラグ
      visibleDialogFlag: false, // 開閉用ダイアログフラグ
      isFetch: false, // 再読み込みフラグ
      isCompanyBranchDependency:
        isLoginUserPartnerCompany() &&
        SessionStorageService.isCommonPartnerCompany(), // 依存関係フラグ(支店プルダウン用)
      isLoading: true, // ロード中フラグ
      isNewSearch: false, // 検索ボタン押下時のフラグ(BLDE_V2-41384)
      searchParams: {
        clearFlag: false,
      },
      visibleExpiredUsageModal: false,
      selectedField: {},
      selectedServiceId: null,
      // オプション利用履歴
      userIntegrated: null,
      isLoadingUser: true,
      totalPartnerCompanies: 0,
      listUsingServices: LIST_SERVICES,
      listDataJV: [],
      visibleDialogJVList: false,
      ccusStatusDialog: {},
    };

    this.role_id = LocalStorageService.getRoleId(); // ロールID
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.isAllowEdit = isPrimaryCompanyRoleId(LocalStorageService.getRoleId());
    this.userId = LocalStorageService.getUserId();
    this.company_id = SessionStorageService.getCompanyId();

    this.handleChangeFieldId = this.handleChangeFieldId.bind(this);

    this.callbacks = [
      {
        type: MY_EVENT.SEARCH_FORM_CHANGE, // 検索フォームの変更イベント
        callback: (val, key, isFetch) => {
          const params = _.cloneDeep(this.state.params);
          if (!_.has(params, key)) {
            params.offset = 0;
          }

          if (!_.isNull(val)) {
            params[key] = val;
          } else {
            delete params[key];
          }

          if (isFetch) {
            this.setState({ params, isFetch });
          } else {
            const tempParams = _.cloneDeep(this.state.tempParams);
            tempParams[key] = val;
            this.setState({ tempParams, isFetch });
          }
        },
      },
    ];

    // イベントにコールバックを設定
    _.each(this.callbacks, val =>
      LocalEventMg.addEventListener(val.type, val.callback)
    );
  }

  /**
   * 現場IDの変更イベントをキャッチして数字以外を除去した上でstateに反映する
   * @param {object} event イベントオブジェクト
   */
  handleChangeFieldId = event => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    const tempParams = _.cloneDeep(this.state.tempParams);
    tempParams.field_id = event.target.value;
    this.setState({ tempParams });
  };

  /**
   * @description 現場IDの先頭ゼロ文字を除去する
   * @param {String} fieldId 現場ID
   * @returns 先頭のゼロ文字が削除された数字
   */
  getSuppressedFieldId = fieldId => {
    if (!isNullOrEmpty(fieldId)) {
      fieldId = _.toNumber(fieldId) == 0 ? '0' : _.trimStart(fieldId, '0');
    }
    return fieldId;
  };

  /**
   * 現場選択時の処理
   * @param {object}fieldData：選択した現場情報
   * @param {?number}serviceId：遷移先のBuildeeのサービスID（nullの場合は、現場のサービス利用状況とユーザーのサービス権限に応じて設定）
   * @param {function} toggleExpiredUsageModal 利用終了ダイアログ開閉
   * @param {function} isExpiredUsage 利用終了判定
   * */
  selectField = async (
    fieldData,
    serviceId,
    toggleExpiredUsageModal,
    isExpiredUsage
  ) => {
    let permission = false;
    const companyId = getCompanyId();
    if (_.isNil(serviceId)) {
      // 遷移先のサービスが未定の場合は、現場情報とサービス権限を考慮して遷移先を取得
      serviceId = await getAvailableServiceId(fieldData, companyId);
      if (!_.isNil(serviceId)) {
        permission = true;
      }
    } else {
      // 遷移先のサービが決まっている場合は、遷移先にサービス権限があるかを確認
      permission = await getPermissionByServiceIdAndCompanyId(
        serviceId,
        companyId
      );
    }

    if (permission) {
      if (typeof toggleExpiredUsageModal === 'function' && isExpiredUsage()) {
        toggleExpiredUsageModal(fieldData, serviceId);
        return;
      }
      const result = await saveFieldData(fieldData.id, this.role);
      if (result) {
        goChangedFieldPage(serviceId);
      }
    } else {
      dialogLoader.show(noPermissionDialog, {
        callback: {
          done: () => {
            dialogLoader.close();
          },
        },
      });
    }
  };

  componentDidMount() {
    this.getUserProfile();
    this.getPartnerList();
    this.getInfoCompany();
  }

  componentDidUpdate() {
    if (this.state.searchParams.clearFlag === true) {
      this.setState({
        searchParams: {
          clearFlag: false,
        },
      });
    }
  }

  componentWillUnmount() {
    // 追加したイベントを削除
    _.each(this.callbacks, val => {
      LocalEventMg.removeEventListener(val.type, val.callback);
    });
  }

  showSetFieldsSessionPartner = () => {
    this.setState({ showFieldsSessionPartner: true });
  };

  toggleSearchForm = () => {
    const { isSearchFormOpen } = this.state;
    this.setState({ isSearchFormOpen: !isSearchFormOpen });
  };

  /**
   * ログイン直後イベントの次のイベント
   * @param {object} company 選択した元請会社
   */
  eventsAfterSomeEventsBeforeShowFields = (company = {}) => {
    if (company) {
      // 選択した元請会社情報をsessionに保存
      const sessionPartnerCompanyIdOfPrimeCompany = company.partner_company_id;
      if (sessionPartnerCompanyIdOfPrimeCompany) {
        SessionStorageService.setItem(
          'company_id',
          sessionPartnerCompanyIdOfPrimeCompany
        );
        SessionStorageService.setItem(
          'prime_company_id',
          sessionPartnerCompanyIdOfPrimeCompany
        );
        SessionStorageService.setItem(
          'company_branch_id',
          company.company_branches ? company.company_branches.id : null
        );
        SessionStorageService.setPartnerCompanyJoiningFlag(
          company.partner_company_joining_flag
        );
      }

      // 現場選択後のSessionStorage設定値の初期化
      SessionStorageService.removeItem('field_tree_id');
      SessionStorageService.removeItem('field_tree_user_id');
      SessionStorageService.removeItem('date_from');
      SessionStorageService.removeItem('date_to');
      SessionStorageService.removeItem('work_hour_zone');
      SessionStorageService.removeItem('working_time');
      SessionStorageService.removeItem('work_start_time');
      SessionStorageService.removeItem('work_start_time_night');
      SessionStorageService.removeItem('work_start_time_midnight');
      SessionStorageService.removeItem('work_end_time');
      SessionStorageService.removeItem('work_end_time_night');
      SessionStorageService.removeItem('work_end_time_midnight');
      SessionStorageService.removeItem('use_gk_flg');
      SessionStorageService.removeItem('use_roan_flg');
      SessionStorageService.removeItem('prime_company_id');
      SessionStorageService.removeItem('field_id');
      setFieldNameForGTM('');

      // ログイン直後フラグをfalse
      SessionStorageService.setAfterLoginEventsFlag(false);

      // 画面を再構築
      window.location.href = '/conference/Fields/0/0/0/0';
    }
  };

  /**
   * @description 現場情報取得
   * @param {array} list_data 取得現場
   */
  loadFields = async list_data => {
    if (SessionStorageService.getDirectLink()) {
      // 直リンク遷移中はロードしない
      return [];
    }

    const params = this.sortForParam(this.state.params);
    params.field_id = this.getSuppressedFieldId(params.field_id);

    if (!_.isEmpty(list_data)) {
      params.offset = list_data.length;
    }

    const data = await fetchMg
      .GetAjax(`/api/private/fields/list`, params)
      .catch(() => ({ result: false }));

    const fields = _.get(data, 'data.entities.fields', []);

    // ソート用パラメータが
    // sort_company_name か sort_branch_name を使用する場合には
    // params.order = company_asc か company_desc か branch_asc か branch_desc に修正する
    if (_.has(params, 'sort_company_name')) {
      params.order = `company_${params.sort_company_name}`;
      delete params.sort_company_name;
    }
    if (_.has(params, 'sort_branch_name')) {
      params.order = `branch_${params.sort_branch_name}`;
      delete params.sort_branch_name;
    }

    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = false;
    }
    this.setState({
      total: _.get(data, 'data.total', 0),
      isFetch: false,
      isLoading: false,
      isNewSearch: false,
    });

    if (isPartnerCompany(roleIdToRoleName(this.role_id))) {
      // 協力会社ユーザーなら
      const companies = _.map(fields, field => ({
        name: field.company.company_name,
        id: field.company.company_id,
      }));

      if (!SessionStorageService.isCommonPartnerCompany()) {
        let useCompanyId;
        if (isLoginUserPartner()) {
          const key = 'sessionPrimeCompanyId';
          const primeId = SessionStorageService.getItem(key);
          const companyId = params.company_id;
          useCompanyId = !isNullOrEmpty(companyId) ? companyId : primeId;
        } else {
          useCompanyId = companies.length > 0 ? companies[0].id : null;
        }

        this.setState({
          params: {
            ...this.state.params,
            company_id: useCompanyId,
          },
          tempParams: {
            ...this.state.tempParams,
            company_id: useCompanyId,
          },
        });
      }

      // 元請け一覧を検索フォームに渡す
      LocalEventMg.trigger(MY_EVENT.GET_COMPANY, companies);
    }

    return fields;
  };

  sortForParam = params => {
    const result = _.cloneDeep(params);
    const deleteServiceFlag = flg => {
      if (_.isEqual(Number(result[flg]), ENTER_STATUS.out.id)) {
        delete result[flg];
      }
    };

    _.forEach(LIST_SERVICES, service => {
      deleteServiceFlag(`${service.FLAG}`);
    });

    // ソート用パラメータ params.order が
    // company_asc か company_desc か branch_asc か branch_desc の場合
    // パラメータを切り替える
    delete result.sort_company_name;
    delete result.sort_branch_name;
    switch (result.order) {
      case 'company_asc':
        result.sort_company_name = 'asc';
        delete result.order;
        break;
      case 'company_desc':
        result.sort_company_name = 'desc';
        delete result.order;
        break;
      case 'branch_asc':
        result.sort_branch_name = 'asc';
        delete result.order;
        break;
      case 'branch_desc':
        result.sort_branch_name = 'desc';
        delete result.order;
        break;
      case undefined:
        result.order = 'groundbreaking_date_desc';
        break;
    }
    return result;
  };

  /**
   * @description 検索実行
   */
  searchExecution = () => {
    this.searchButtonRef.current.disabled = true;

    const tempParams = _.cloneDeep(this.state.tempParams);
    const currentParams = _.cloneDeep(this.state.params);
    delete tempParams.order;
    tempParams.offset = 0;
    const params = { ...currentParams, ...tempParams };

    this.setState({
      params,
      tempParams,
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
    });
  };

  /**
   * @description ページタイトル分岐処理
   */
  getTitle = () => {
    return isPrimaryCompany(roleIdToRoleName(this.role_id))
      ? '現場一覧'
      : '現場確認';
  };

  /**
   * @description 契約有無チェック
   * @param {boolean} isEdit true: 現場詳細, false: 新規現場登録
   * @param {number} fieldId 現場ID
   */
  contractCheck = (isEdit, fieldId) => {
    if (
      this.state.contractFlag === CONTRACT_FLAG.yesContract.id ||
      isTargetRoleId([USER_ROLES.prime], this.role_id)
    ) {
      if (isEdit) {
        const pageParams = {
          id: fieldId,
          pageReferer: PAGE_REFERER.fields.key,
        };
        _masterSlideLoader.show('FieldsDetail', { state: pageParams });
      } else {
        _masterSlideLoader.show('FieldRegister', { state: { id: 1 } });
      }
    } else {
      this.handleVisibleDialog(true);
    }
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogFlag ダイアログフラグ
   */
  handleVisibleDialog = visibleDialogFlag => {
    this.setState({ visibleDialogFlag });
  };

  toggleExpiredUsageModal = (selectedField, selectedServiceId) => {
    const { visibleExpiredUsageModal } = this.state;
    this.setState({
      visibleExpiredUsageModal: !visibleExpiredUsageModal,
      selectedField,
      selectedServiceId,
    });
  };

  handleConfirmFieldExpiredUsage = () => {
    const { selectedField, selectedServiceId } = this.state;
    this.selectField(selectedField, selectedServiceId);
  };

  handleShowDialogJVList = async fieldId => {
    this.setState({ visibleDialogJVList: true });
    const JVLists = await JVListsData(fieldId);
    this.setState({ listDataJV: JVLists.entities.company });
  };

  handleShowDialogCCUS = dataDialog => {
    this.setState({ ccusStatusDialog: dataDialog });
  };

  handleCloseDialogJVList = () => {
    this.setState({ visibleDialogJVList: false, listDataJV: [] });
  };

  /**
   * @description CSV出力準備
   */
  csvDownloadPreparation = () => {
    const params = this.sortForParam(this.state.params);
    params.field_id = this.getSuppressedFieldId(params.field_id);

    const apiPath = 'api/private/fields/list.csv';

    csvDownloader(apiPath, params);
  };

  /**
   * 依存関係_パラメータ削除
   *
   * @param {String} deleteKey 削除キー
   */
  dependencyParamDelete = deleteKey => {
    const params = _.cloneDeep(this.state.params);
    const tempParams = _.cloneDeep(this.state.tempParams);
    delete params[deleteKey];
    delete tempParams[deleteKey];
    this.setState({ params, tempParams });
  };

  showSwitchUser = () => {
    EventManager.trigger(EventType.SHOW_SWITCH_USER_INTEGRATE);
  };

  showSwitchCompany = () => {
    EventManager.trigger(EventType.SHOW_SWITCH_COMPANY);
  };

  getUserProfile = () => {
    this.setState({ isLoadingUser: true });
    UserProfileService.show(this.userId, {})
      .then(response => {
        if (response.result) {
          const integrated =
            _.get(response.data, 'entities.user_profile.integrated') || false;
          const roleCode = _.get(
            response.data,
            'entities.user_profile.role_code'
          );
          this.setState({ userIntegrated: integrated });
          if (checkCallBackGreenFileService()) {
            if (!integrated && isPartnerCompanyRoleId(roleCode)) {
              return this.showSwitchCompany();
            }
            if (integrated) {
              return this.showSwitchUser();
            }
          }
        }
      })
      .finally(() => {
        this.setState({ isLoadingUser: false });
        if (_.isNull(this.state.userIntegrated)) {
          this.setState({ userIntegrated: false });
        }
      });
  };

  getPartnerList = async () => {
    const { result, data } = await CompanyBranchService.primeList();
    if (result) {
      const partnerCompanies = _.get(data, 'entities.company');
      this.setState({ totalPartnerCompanies: _.size(partnerCompanies) });
    }
  };

  getInfoCompany = async () => {
    const listUsingServices = _.cloneDeep(this.state.listUsingServices);
    const { result, data } = await CompanyService.show(this.company_id);
    if (result) {
      const available_progress_flg = _.get(
        data,
        'entities.company.available_progress_flg'
      );
      if (!available_progress_flg) {
        delete listUsingServices.PROGRESS;
      }
      this.setState({ listUsingServices });
    }
  };

  render() {
    const {
      params,
      tempParams,
      total,
      isSearchFormOpen,
      afterLoginEventsFlag,
      userRoleId,
      visibleDialogFlag,
      isFetch,
      isCompanyBranchDependency,
      isLoading,
      isNewSearch,
      visibleExpiredUsageModal,
      userIntegrated,
      isLoadingUser,
      listUsingServices,
      visibleDialogJVList,
      ccusStatusDialog,
    } = this.state;

    // 後に追加可能
    const eventsAfterLoginByUserRoles = {
      partner: afterLoginEventsFlag && isPartnerRoleId(userRoleId), // ログイン直後・協力会社管理者の場合
    };

    const eventAfterSwitchUser = afterLoginEventsFlag && userIntegrated;

    return (
      <div
        className='master-slide-view show'
        style={{
          display: SessionStorageService.getDirectLink() ? 'none' : 'block',
        }}
      >
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.getTitle()}
          </title>
        </Helmet>
        <div className='master-slide-view__view'>
          <TitleHeader title={this.getTitle()} />
          <div
            id='infinityscroll-target'
            className='master-slide-view__table FieldsTable'
          >
            <HeaderMenu
              onCsvDownloadPreparation={this.csvDownloadPreparation}
              setSessionPartner={this.showSetFieldsSessionPartner.bind(this)}
              onContractCheck={this.contractCheck}
              userIntegrated={this.state.userIntegrated}
              showSwitchUser={this.showSwitchUser}
              showSwitchCompany={this.showSwitchCompany}
              totalPartnerCompanies={this.state.totalPartnerCompanies}
            />
            <SearchForm
              param={tempParams}
              onOpen={this.toggleSearchForm}
              onSearchExecution={this.searchExecution}
              searchButtonRef={this.searchButtonRef}
              isOpen={isSearchFormOpen}
              isCompanyBranchDependency={isCompanyBranchDependency}
              onDependencyParamDelete={this.dependencyParamDelete}
              isLoading={isLoading}
              total={total}
              searchParams={this.state.searchParams}
              setState={this.setState}
              listUsingServices={listUsingServices}
              clearParams={() => {
                _.each(
                  document.querySelectorAll('.search-form__body input'),
                  input => {
                    input.value = null;
                    input.checked = null;
                  }
                );

                const params = {
                  offset: 0,
                  limit: REQUEST_PARAMS.parentLimit,
                  approval_flag: APPROVAL_STATUS.approval.id,
                  usage_status: [],
                  ccus_register_status: [],
                  company_id: isPartnerCompany(
                    roleIdToRoleName(LocalStorageService.getRoleId())
                  )
                    ? null
                    : SessionStorageService.getItem('company_id'),
                };
                this.setState({
                  params,
                  tempParams: params,
                  isFetch: true,
                  isLoading: true,
                  isNewSearch: true,
                  searchParams: {
                    clearFlag: true,
                    name: '',
                  },
                });
              }}
              handleChangeFieldId={this.handleChangeFieldId}
            />

            <div className='master-slide-view__body'>
              <div className={`${styles.fields_table} constructionlist__list`}>
                {eventsAfterLoginByUserRoles.partner || eventAfterSwitchUser
                  ? ''
                  : !isLoadingUser && (
                      <Table
                        parentId='infinityscroll-target'
                        onLoad={this.loadFields}
                        // eslint-disable-next-line no-unused-vars
                        header={props => (
                          <TableHeader
                            order={_.defaultTo(params.order, '')}
                            isAllowEdit={this.isAllowEdit}
                          />
                        )}
                        body={props => (
                          <TableItem
                            {...props}
                            roleId={this.role_id}
                            onContractCheck={this.contractCheck}
                            selectField={this.selectField}
                            toggleExpiredUsageModal={
                              this.toggleExpiredUsageModal
                            }
                            isAllowEdit={this.isAllowEdit}
                            handleShowDialogJVList={this.handleShowDialogJVList}
                            handleShowDialogCCUS={this.handleShowDialogCCUS}
                          />
                        )}
                        isFetch={isFetch}
                        isLoading={isLoading}
                        isNewSearch={isNewSearch}
                      />
                    )}
              </div>
            </div>
          </div>
          {eventsAfterLoginByUserRoles.partner ? '' : <FieldsSystemNotices />}
        </div>
        <Information
          visible={visibleDialogFlag}
          message={messageUtility.getMessage('E-000-037')}
          buttonText={messageUtility.getMessage('I-000-011')}
          onClose={() => this.handleVisibleDialog(false)}
          buttonClassName='btn--sm--sub'
        />
        <Information
          visible={visibleDialogJVList}
          title={messageUtility.getMessage('I-000-236')}
          message={<JVListData listDataJV={this.state.listDataJV} />}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.handleCloseDialogJVList}
          rootClassName='dialog--wide'
        />
        <Information
          visible={!_.isEmpty(ccusStatusDialog)}
          title={ccusStatusDialog.title}
          message={ccusStatusDialog.message}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleShowDialogCCUS({})}
          rootClassName='dialog--wide'
          multilineText={true}
        />
        <FieldsExpiredUsageModal
          visible={visibleExpiredUsageModal}
          onClose={this.toggleExpiredUsageModal}
          onConfirm={this.handleConfirmFieldExpiredUsage}
          onCancel={this.toggleExpiredUsageModal}
        />
      </div>
    );
  }
}

/**
 * @description ヘッダーのソート関数
 * @param {String} key ソートするKey名
 * @param {String} order 前回のソート内容
 */
const onSort = (key, order) => {
  LocalEventMg.trigger(
    MY_EVENT.SEARCH_FORM_CHANGE,
    order === `${key}_asc` ? `${key}_desc` : `${key}_asc`,
    'order',
    true
  );
};

/**
 * @description リスト一覧のヘッダー部分
 * @param {string} order ソートパラメータ
 */
const TableHeader = ({ order, isAllowEdit }) => {
  const HeaderCell = ({ children, sortKey }) => {
    const handleSort = () => sortKey && onSort(sortKey, order);

    return (
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' onClick={handleSort}>
          {children}
          {sortKey && getSortButton(order, sortKey)}
        </div>
      </td>
    );
  };

  return (
    <thead className='table__header'>
      <tr className='table__label'>
        <UserTypeSwitchForm
          match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
        >
          <HeaderCell sortKey='company'>元請名</HeaderCell>
        </UserTypeSwitchForm>
        <HeaderCell sortKey='branch'>支店名</HeaderCell>
        <HeaderCell sortKey='name'>現場名</HeaderCell>
        <HeaderCell sortKey='address'>住所</HeaderCell>
        <HeaderCell sortKey='groundbreaking_date'>着工日</HeaderCell>
        <HeaderCell sortKey='complete_schedule_date'>竣工日</HeaderCell>
        <HeaderCell>ステータス</HeaderCell>
        <HeaderCell>利用中のサービス</HeaderCell>
        {isAllowEdit && <HeaderCell />}
      </tr>
    </thead>
  );
};

/**
 * @description テーブル内に取得現場を表示
 */
class TableItem extends React.Component {
  constructor(props) {
    super(props);
    this.isPrimaryCompanyRole = isPrimaryCompanyRoleId(props.roleId);
  }

  isExpiredUsage = () => {
    const { data } = this.props;
    const status = getFieldStatus(data);
    return status.ID === FIELD_COMPLETE_STATUS.EXPIRED.ID;
  };

  handleSelect = serviceId => {
    const { data, selectField, toggleExpiredUsageModal } = this.props;
    selectField(data, serviceId, toggleExpiredUsageModal, this.isExpiredUsage);
  };

  /**
   * 労務安全アイコンクリック
   * */
  clickRoanIcon = event => {
    event.stopPropagation();
    this.handleSelect(BUILDEE_SERVICES.ROAN.ID);
  };

  /**
   * 入退場アイコンクリック
   * */
  clickNyutaiIcon = event => {
    event.stopPropagation();
    this.handleSelect(BUILDEE_SERVICES.NYUTAI.ID);
  };

  /**
   * 調整会議アイコンクリック
   * */
  clickChoseiIcon = event => {
    event.stopPropagation();
    this.handleSelect(BUILDEE_SERVICES.CONFERENCE.ID);
  };

  /**
   * 進捗・歩掛アイコンクリック
   * */
  clickProgressIcon = event => {
    event.stopPropagation();
    this.handleSelect(BUILDEE_SERVICES.PROGRESS.ID);
  };

  /**
   * 車両管理アイコンクリック
   * */
  clickTrackerIcon = event => {
    event.stopPropagation();
    this.handleSelect(BUILDEE_SERVICES.TRACKER.ID);
  }

  /**
   * 現場行をクリック
   * */
  clickField = () => {
    this.handleSelect();
  };

  /**
   * @description ステータス
   * @param {object} data 現場情報
   */
  getStatusIcons = () => {
    const { data } = this.props;
    const status = getFieldStatus(data);

    switch (status.ID) {
      case FIELD_COMPLETE_STATUS.EXPIRED.ID:
        return (
          <span className='value-table__content'>
            <StatusTag type='suspension'>利用終了</StatusTag>
          </span>
        );
      case FIELD_COMPLETE_STATUS.COMPLETED.ID:
        return (
          <span className='value-table__content'>
            <StatusTag short>竣工</StatusTag>
          </span>
        );
      default:
        return null;
    }
  };

  clickJVIcon = event => {
    event.stopPropagation();
    this.props.handleShowDialogJVList(this.props.data.id);
  };

  // TODO 1末リリース以降現場の遷移に問題なければ下記処理は削除
  // /**
  //  * ツリー情報取得
  //  *  協力会社管理者、職長、の時のみ施工体系図(field_tree)のIDと関連付けられる
  //  * @param {object} field 現場情報
  //  * @param {number} roleId ロールID
  //  */
  // getPartnerUserSelfIds = (field, roleId) => {
  //   FieldTreeService.partnerUserSelfIds(field.id).then(response => {
  //     if (response.result) {
  //       const entity = response.data.entities;
  //       sessionStorage.setItem('field_tree_id', entity.field_tree.id);
  //       sessionStorage.setItem('field_tree_user_id', entity.field_tree_user.id);
  //       if (roleId === USER_ROLES.foreman.id) {
  //         FieldTreeService.show(
  //           field.id,
  //           entity.field_tree.id,
  //           entity.field_tree_user.id
  //         ).then(response => {
  //           if (response.result) {
  //             const fieldTreeUser = response.data.entities.field_tree_user;
  //             if (!_.isEmpty(fieldTreeUser.field_tree_user_jobs)) {
  //               sessionStorage.setItem(
  //                 'job_id',
  //                 fieldTreeUser.field_tree_user_jobs[0].job_id
  //               );
  //             }
  //             this.setFieldData(field);
  //           }
  //         });
  //       } else {
  //         this.setFieldData(field);
  //       }
  //     }
  //   });
  // };

  // TODO 1末リリース以降現場の遷移に問題なければ下記処理は削除
  // /**
  //  * @description 選択した現場を設定
  //  * @param {object} field 現場情報
  //  */
  // setFieldData = async (field) => {
  //   //現場情報更新
  //   SessionsService.updatefield(field.id).then(async resp => {
  //     if (!resp.result) {
  //       console.error(
  //         '選択現場の更新に失敗しました',
  //         'Fields.jsx',
  //         'setFieldData',
  //         'SessionsService.updatefield',
  //         resp
  //       );
  //       return;
  //     }
  //     await FieldService.info(field.id)
  //       .then(response => {
  //         if (!response.result) {
  //           console.error(
  //             'Fields.jsx',
  //             'setFieldData',
  //             'FieldService.info !response.result',
  //             response
  //           );
  //           return;
  //         }
  //         return changeFieldWriteStorage(response.data.entities.field);
  //       })
  //       .catch(error => {
  //         console.error(
  //           'Fields.jsx',
  //           'setFieldData',
  //           'FieldService.info catch',
  //           error
  //         );
  //       });
  //
  //     goChangedFieldPage();
  //   });
  // };

  renderDataWithTooltip = data => {
    const content = data || '';
    return (
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={<ToolTip>{content}</ToolTip>}
      >
        <div className='value-table__txt--10'>{content}</div>
      </Tippy>
    );
  };

  render() {
    const { data, roleId, isAllowEdit } = this.props;
    let roanActive = false;
    let nyutaiActive = false;
    let choseiActive = false;
    let progressActive = false;
    let trackerActive = false;
    if (
      isPartnerCompanyRoleId(roleId) &&
      !SessionStorageService.isCommonPartnerCompany()
    ) {
      // 固有協力会社の場合は労務安全も入退場利用不可
      roanActive = false;
      nyutaiActive = false;
      choseiActive = false;
      progressActive = false;
      trackerActive = false;
    } else {
      roanActive = data.use_roan_flg;
      nyutaiActive = data.use_gk_flg;
      choseiActive = data.use_chosei_flg;
      progressActive = data.use_progress_flg;
      trackerActive = data.use_tracker_flg;
    }

    return (
      <tr
        className={`table__item enable${
          this.isExpiredUsage() ? ' table__item--suspension' : ''
        }`}
        onClick={this.clickField}
        data-qa={`fields_table-item-${data.id}`}
      >
        <UserTypeSwitchForm
          match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
        >
          <td
            className={`value-table construction-list-value-table__branch-name value-table ${
              isPartnerCompanyRoleId(roleId)
                ? 'construction-list-value-table__branch-name--partner'
                : ''
            }`}
          >
            <span className='label'>元請名</span>
            <div className='value-table__txt'>
              {data.company.company_name || ''}
            </div>
          </td>
        </UserTypeSwitchForm>
        <td
          className={`value-table construction-list-value-table__branch-name value-table ${
            isPartnerCompanyRoleId(roleId)
              ? 'construction-list-value-table__branch-name--partner'
              : ''
          }`}
        >
          <span className='label'>支店名</span>
          {!this.isPrimaryCompanyRole ? (
            <div className='value-table__txt'>
              {data.company.company_branch_name || ''}
            </div>
          ) : (
            <React.Fragment>
              {_.map(data.companies_fields, (companyBranch, index) =>
                renderTooltipTable(companyBranch.company_branch_name, index)
              )}
            </React.Fragment>
          )}
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>現場名</span>
          <div className='value-table__name'>
            {!_.isEmpty(data.jvs) && this.isPrimaryCompanyRole && (
              <div
                className='jv__btn clickable-text'
                onClick={this.clickJVIcon}
              />
            )}
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={<ToolTip>{data.name}</ToolTip>}
            >
              <div className='value-table__txt'>{data.name}</div>
            </Tippy>
          </div>
          <div className='value-table__name'>
            <div className='value-table__field-id'>ID：{data.id}</div>
            {!!data.ccus_register_status && (
              <div
                className='ccus-status-registered clickable-text'
                onClick={event => {
                  event.stopPropagation();
                  this.props.handleShowDialogCCUS({
                    title: 'CCUS情報',
                    message: (
                      <div className='text-center bold'>
                        CCUS現場ID：{data.ccus_site_id}
                      </div>
                    ),
                  });
                }}
              />
            )}
          </div>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>住所</span>
          {this.renderDataWithTooltip(data.address)}
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>着工日</span>
          <div className='value-table__date'>
            {data.groundbreaking_date
              ? moment(data.groundbreaking_date).format('YYYY/MM/DD')
              : ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>竣工日</span>
          <div className='value-table__date'>
            {data.complete_schedule_date
              ? moment(data.complete_schedule_date).format('YYYY/MM/DD')
              : ''}
          </div>
        </td>
        <td
          className={`${styles.status} value-table construction-list-value-table__option`}
        >
          <span className='label'>ステータス</span>
          <div className='value-table__normal'>{this.getStatusIcons()}</div>
        </td>
        <td
          className={`${styles.option} value-table construction-list-value-table__option`}
        >
          <span className='label'>オプション</span>
          <div className='value-table__normal value-table__normal--wide'>
            <span className='value-table__content'>
              {choseiActive ? (
                <div
                  className='option-icon-chosei clickable'
                  onClick={this.clickChoseiIcon}
                />
              ) : (
                <div className='option-icon-empty' />
              )}
            </span>
            <span className='value-table__content'>
              {nyutaiActive ? (
                <div
                  className='option-icon-entrance clickable'
                  onClick={this.clickNyutaiIcon}
                />
              ) : (
                <div className='option-icon-empty' />
              )}
            </span>
            <span className='value-table__content'>
              {roanActive ? (
                <div
                  className='option-icon-greenfile clickable'
                  onClick={this.clickRoanIcon}
                />
              ) : (
                <div className='option-icon-empty' />
              )}
            </span>
            <span className='value-table__content'>
              {progressActive ? (
                <div
                  className='option-icon-progress clickable'
                  onClick={this.clickProgressIcon}
                />
              ) : (
                <div className='option-icon-empty' />
              )}
            </span>
            <span className='value-table__content'>
              {trackerActive ? (
                <div
                  className='option-icon-tracker clickable'
                  onClick={this.clickTrackerIcon}
                />
              ) : (
                <div className='option-icon-empty' />
              )}
            </span>
          </div>
        </td>
        {isAllowEdit && (
          <td className='value-table construction-list-value-table__edit'>
            {/* ボタン */}
            <PrimeContractorButton
              label='編集'
              buttonClass='btn--sm--stay'
              onClick={e => {
                e.stopPropagation();
                this.props.onContractCheck(true, data.id);
              }}
            />
          </td>
        )}
      </tr>
    );
  }
}

/**
 * @description タイトルヘッダー
 * @param {string} title ページタイトル
 */
const TitleHeader = ({ title }) => (
  <MasterPageHeader title={title} onClose={() => _masterSlideLoader.close()} />
);

/**
 * @description ヘッダーメニュー
 */
const HeaderMenu = props => (
  <div className='master-slide-view__menu'>
    <ul className='btn-menu space-between-btn'>
      <li className='btn-menu__item'>
        <PrimeToBranchButton
          label={'新規作成'}
          buttonClass={'btn'}
          onClick={() => props.onContractCheck(false)}
        />
      </li>
      {props.userIntegrated === true && (
        <li className='btn-menu__item'>
          <RoleButton
            label={'操作ユーザー選択'}
            buttonClass={'btn'}
            onClick={props.showSwitchUser}
            show={true}
          />
        </li>
      )}
      {props.userIntegrated === false &&
        isLoginUserPartner() &&
        props.totalPartnerCompanies > 1 && (
          <li className='btn-menu__item'>
            <RoleButton
              label={'操作ユーザー選択'}
              buttonClass={'btn'}
              onClick={props.showSwitchCompany}
              show={true}
            />
          </li>
        )}
      <li className='btn-menu__item'>
        <PrimeToBranchButton
          label='表示データをCSV出力'
          buttonClass='btn--sub'
          onClick={props.onCsvDownloadPreparation}
        />
      </li>
    </ul>
  </div>
);

/**
 * @description 検索フォームヘッダー
 * @param {function} onOpen 検索フォーム開閉処理
 * @param {boolean} isOpen true: オープン, false: クローズ
 * @param {number} total 取得現場件数
 * @param {function} clearParams 検索条件クリア処理
 */
const SearchFormHeader = ({ onOpen, isOpen, total, clearParams }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button className='btn-text--sm' onClick={clearParams}>
      検索条件クリア
    </button>
  </div>
);

/**
 * @description 検索フォーム_ラジオボタン
 * @param {string} label ラベル名
 * @param {number} name ラジオボタン名
 * @param {number} value 定数
 */
const SearchFormRadio = ({ label, name, value }) => (
  <div className='element__item'>
    <label className='radio'>
      <input
        name={`radio-${name}`}
        type='radio'
        onChange={() =>
          LocalEventMg.trigger(MY_EVENT.SEARCH_FORM_CHANGE, value, name, false)
        }
      />
      <i className='i-2x' />
      <span>{label}</span>
    </label>
  </div>
);

/**
 * @description 検索フォーム_チェックボックス
 * @param {string} label ラベル名
 * @param {number} name ラジオボタン名
 * @param {number} value 定数
 */
const SearchFormCheckbox = ({ name, label, value, param }) => (
  <div className='element__item'>
    <label
      htmlFor='checkbox'
      className='checkbox'
      key={`checkbox-${name}-${value}`}
      onClick={() => {
        if (param[name].includes(value)) {
          LocalEventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            param[name].filter(item => item !== value),
            name,
            false
          );
          // setState({...param, name: valueList.filter(item => item !== key)})
        } else {
          // setState({...param, name: valueList.concat(key)})
          LocalEventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            param[name].concat(value),
            name,
            false
          );
        }
      }}
    >
      <input
        name='checkbox'
        type='checkbox'
        checked={param[name].includes(value)}
        readOnly
      />
      <i className='i-3x' />
      <span>{label}</span>
    </label>
  </div>
);

/**
 * @param {string} label ラベル名
 * @param {number} name ラジオボタン名
 * @param {number} value 定数
 */
const SearchFormServiceCheckbox = ({ name, label, value, param }) => (
  <div className='element__item'>
    <label
      htmlFor='checkbox'
      className='checkbox'
      key={`checkbox-${name}-${value}`}
      onClick={() => {
        if (_.isEqual(Number(param[name]), ENTER_STATUS.enter.id)) {
          LocalEventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            (param[name] = ENTER_STATUS.out.id),
            name,
            false
          );
        } else {
          LocalEventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            (param[name] = ENTER_STATUS.enter.id),
            name,
            false
          );
        }
      }}
    >
      <input
        name='checkbox'
        type='checkbox'
        checked={_.isEqual(param[name], ENTER_STATUS.enter.id)}
        readOnly
      />
      <i className='i-3x' />
      <span>{label}</span>
    </label>
  </div>
);

/**
 * @description 検索フォーム_テキスト
 * @param {string} name テキスト名
 * @param {string} placeholder プレースホルダー
 * @param {string} val
 * @param {function} handleOnChange
 */
const SearchFormTextInput = ({ name, placeholder, val, handleOnChange }) => (
  <input
    type='text'
    placeholder={placeholder}
    data-qa='fields_field-search-input'
    value={val}
    onChange={handleOnChange}
    onBlur={e =>
      LocalEventMg.trigger(
        MY_EVENT.SEARCH_FORM_CHANGE,
        e.target.value,
        name,
        false
      )
    }
  />
);

/**
 * @description 検索フォームグループ
 * @param {string} label ラベル名
 * @param {*} children
 * @param {string} eleClass クラス名
 */
const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);

/**
 * @description 検索フォーム_元請会社コンポーネント(協力会社管理者, 職長専用)
 */

const Company = ({ searchParams }) => {
  const callback = val => {
    LocalEventMg.trigger(
      MY_EVENT.SEARCH_FORM_CHANGE,
      val.id,
      'company_id',
      false
    );
  };

  return (
    <div className='form-element'>
      <div className='form-element__label'>
        <span className='label'>元請名</span>
      </div>
      <div className='form-element__element'>
        <PrimeEnabler>
          <div>
            <FormDropDownSingleSelect
              label={SELECT_COMPANY_NAME_LABEL}
              selectKey='id'
              placeholder={SELECT_COMPANY_NAME_LABEL}
              apiPath='/api/private/companies/field_prime_list'
              entitiesKey='companies'
              params={searchParams}
              callback={callback}
              isOptional={true}
              className={'company'}
            />
          </div>
        </PrimeEnabler>
      </div>
    </div>
  );
};

/**
 * @description 検索フォーム_支店名コンポーネント
 */
const Shiten = ({
  isCompanyBranchDependency,
  onDependencyParamDelete,
  param,
  searchParams,
}) => {
  const { name, clearFlag } = searchParams;
  const { company_id } = param;
  const params = isNullOrUndefined(name)
    ? { company_id }
    : { company_id, name, clearFlag };

  const callback = val => {
    LocalEventMg.trigger(
      MY_EVENT.SEARCH_FORM_CHANGE,
      val.id,
      'company_branch_id',
      false
    );
  };

  return (
    <div className='form-element'>
      <div className='form-element__label'>
        <span className='label'>支店名</span>
      </div>
      <div className='form-element__element form-element__element--fixed-width'>
        <PrimeEnabler>
          <div>
            <FormDropDownSingleSelect
              label={SEARCH_COMPONENT_BRANCH_LABEL}
              selectKey='id'
              placeholder='支店名を入力して検索'
              apiPath='/api/private/company_branches/list'
              entitiesKey='company_branches'
              cancelItemFlag={true}
              isDependency={isCompanyBranchDependency}
              dependencyKey='company_id'
              dependencyDeleteKey='company_branch_id'
              dependencyProcess={onDependencyParamDelete}
              isApiStop={isNullOrEmpty(company_id)}
              params={params}
              callback={callback}
              isOptional={true}
            />
          </div>
        </PrimeEnabler>
      </div>
    </div>
  );
};

/**
 * @description 検索フォーム
 * @param {function} onOpen 検索フォーム開閉処理
 * @param {boolean} isOpen true: オープン, false: クローズ
 * @param {number} total 取得現場件数
 * @param {function} clearParams 検索条件クリア処理
 */
const SearchForm = ({
  param,
  onOpen,
  onSearchExecution,
  searchButtonRef,
  isOpen,
  isCompanyBranchDependency,
  onDependencyParamDelete,
  isLoading,
  total,
  clearParams,
  searchParams,
  listUsingServices,
  handleChangeFieldId,
}) => (
  <div className='master-slide-view__searchform'>
    <div className='search-form'>
      <SearchFormHeader
        onOpen={onOpen}
        isOpen={isOpen}
        total={total}
        clearParams={clearParams}
      />
      <div
        id='search-form-accordion'
        className={isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body set-width-dropdown'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <Shiten
                param={param}
                searchParams={searchParams}
                isCompanyBranchDependency={isCompanyBranchDependency}
                onDependencyParamDelete={onDependencyParamDelete}
              />

              <SearchFormElement
                label='現場名'
                eleClass='form-element__element --col-xs-12 --col-md-12 --col-lg-9 --col-xl-9'
              >
                <SearchFormTextInput
                  name='name'
                  placeholder='現場名'
                  val={searchParams.name}
                />
              </SearchFormElement>

              <SearchFormElement
                label='現場ID'
                eleClass='form-element__element --col-xs-12 --col-md-12 --col-lg-9 --col-xl-9'
              >
                <SearchFormTextInput
                  name='field_id'
                  placeholder='半角数字を入力'
                  val={searchParams.field_id}
                  handleOnChange={handleChangeFieldId}
                />
              </SearchFormElement>

              <UserTypeSwitchForm
                match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
              >
                <Company searchParams={searchParams} />
              </UserTypeSwitchForm>

              <SearchFormElement
                label='CCUS現場登録'
                eleClass='form-element__list'
              >
                {_.map(CCUS_REGISTER_STATUS, ({ ID, NAME }) => (
                  <SearchFormCheckbox
                    name='ccus_register_status'
                    label={NAME}
                    value={ID}
                    key={ID}
                    param={param}
                  />
                ))}
              </SearchFormElement>

              <SearchFormElement
                label='ステータス'
                eleClass='form-element__list'
              >
                {_.map(FIELD_COMPLETE_STATUS, ({ ID, NAME }) => (
                  <SearchFormCheckbox
                    name='usage_status'
                    label={NAME}
                    value={ID}
                    key={ID}
                    param={param}
                  />
                ))}
              </SearchFormElement>

              <SearchFormElement
                label='利用中のサービス'
                eleClass='form-element__list form-element__list--service'
              >
                <div>
                  {_.map(listUsingServices, ({ ID, NAME, FLAG }) => (
                    <SearchFormServiceCheckbox
                      name={FLAG}
                      label={NAME}
                      value={ID}
                      key={ID}
                      param={param}
                    />
                  ))}
                </div>
                <button
                  className='btn-fixedsize--stay search-form__btn'
                  data-qa='fields_field-search-btn'
                  onClick={onSearchExecution}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
          </div>
        </div>
      </div>
      <div className='help-text'>
        アクセスしたい現場が表示されない場合は
        <a
          className='clickable-text'
          href={ZENDESK_URL_GUIDE.NOT_EXIST_FIELD}
          target='_blank'
          rel='noreferrer noopener'
        >
          こちら
        </a>
        をご確認ください。
      </div>
    </div>
  </div>
);

const renderTooltipTable = (value, key, className = 'value-table__txt') => (
  <div key={key}>
    <Tippy
      duration={10}
      distance={24}
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      html={<ToolTip>{value || ''}</ToolTip>}
    >
      <div className={className}>{value || ''}</div>
    </Tippy>
  </div>
);

const JVListData = ({ listDataJV }) => {
  if (_.isEmpty(listDataJV)) {
    return <div className='indicator' />;
  }

  const mainJV = listDataJV[0];
  const listSubJV = _.tail(listDataJV);
  return (
    <div className='jv-list-dialog__content'>
      <div className='jv-list-dialog__group'>
        <div className='jv-list-dialog__item'>
          {messageUtility.getMessage('I-000-237')}
        </div>
        {renderTooltipTable(
          mainJV.name + '　' + mainJV.company_branch_name,
          mainJV.id,
          'jv-list-dialog__item'
        )}
      </div>
      <div className='jv-list-dialog__group'>
        <div className='jv-list-dialog__item'>
          {messageUtility.getMessage('I-000-245')}
        </div>
        {_.map(listSubJV, subJV =>
          renderTooltipTable(
            subJV.name + '　' + subJV.company_branch_name,
            subJV.id,
            'jv-list-dialog__item'
          )
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Fields.jsx